import { render, staticRenderFns } from "./matrixdynamic.vue?vue&type=template&id=9a0b88e8&"
import script from "./matrixdynamic.vue?vue&type=script&lang=ts&"
export * from "./matrixdynamic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a0b88e8')) {
      api.createRecord('9a0b88e8', component.options)
    } else {
      api.reload('9a0b88e8', component.options)
    }
    module.hot.accept("./matrixdynamic.vue?vue&type=template&id=9a0b88e8&", function () {
      api.rerender('9a0b88e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/matrixdynamic.vue"
export default component.exports